import { styled } from '@mui/material';
import { ReactComponent as IconDollar } from '../../../assets/images/dollar.svg';

export const IconDollarComponent = styled(IconDollar)(() => ({
  height: '24px',
  width: '24px',
  color: 'currentColor',
  cursor: 'pointer',
}));
